import { jsx as _jsx } from "react/jsx-runtime";
import { Info, LoaderCircle, OctagonX, TriangleAlert } from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import { Portal } from "@radix-ui/react-portal";
import { CelebrationCheck } from "../celebration-check/celebration-check";
const Toaster = ({ ...props })=>{
    const { theme = "system" } = useTheme();
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsx(Sonner, {
            theme: theme,
            className: "toaster group",
            icons: {
                success: /*#__PURE__*/ _jsx(CelebrationCheck, {
                    size: "sm"
                }),
                info: /*#__PURE__*/ _jsx(Info, {
                    className: "w-4 h-4"
                }),
                warning: /*#__PURE__*/ _jsx(TriangleAlert, {
                    className: "w-4 h-4"
                }),
                error: /*#__PURE__*/ _jsx(OctagonX, {
                    className: "w-4 h-4"
                }),
                loading: /*#__PURE__*/ _jsx(LoaderCircle, {
                    className: "w-4 h-4 animate-spin"
                })
            },
            toastOptions: {
                classNames: {
                    toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
                    description: "group-[.toast]:text-muted-foreground",
                    actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
                    cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
                }
            },
            ...props
        })
    });
};
export { Toaster };

//# sourceMappingURL=sonner.js.map